import React from "react";

const SimpleItemsPanel = ({ type = "actions", items = [], onDelete, onEdit, onMove, movingItemId = null, movingDirection = null, movingOverItemId = null }) => {
  const isAction = type === "actions";

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <div className="p-4 border-b border-gray-100 flex items-center justify-between">
        <h3 className="text-base font-semibold text-gray-900">{isAction ? "Actions actives" : "Récompenses actives"}</h3>
      </div>
      <div className="p-4 space-y-2">
        {items.length === 0 ? (
          <div className="text-sm text-gray-500">Aucun élément</div>
        ) : (
          items.map((it, index) => {
            const key = (isAction ? it.acId || it.actId : it.rwId) ?? it.id;
            const picture = isAction ? it.acIconURL || it.actIconURL || it.acPictureURL : it.rwIconURL || it.rwPictureURL;
            const useIconPicture = isAction ? Boolean(it.acIconURL || it.actIconURL) : Boolean(it.rwIconURL);
            const title = isAction ? it.display_name || it.acTitle || it.name : it.display_name || it.rwName || it.name;
            const subtitle = it.subtitleFr || it.description;
            const isMoving = movingItemId === key;
            const isTargetDuringMove = movingOverItemId === key && movingItemId !== null;
            return (
              <div
                key={key}
                className={`border rounded-md px-3 py-2 flex items-center justify-between bg-white ${
                  isMoving ? "relative z-20 shadow-xl ring-1 ring-gray-200" : ""
                }`}
                style={
                  isMoving
                    ? {
                        transform: movingDirection === "up" ? "translateY(-108%) scale(1.01)" : "translateY(108%) scale(1.01)",
                        transition: "transform 280ms cubic-bezier(0.22, 1, 0.36, 1), box-shadow 280ms cubic-bezier(0.22, 1, 0.36, 1)",
                        willChange: "transform",
                      }
                    : {
                        transition: "transform 220ms cubic-bezier(0.22, 1, 0.36, 1), opacity 180ms ease-out",
                        opacity: isTargetDuringMove ? 0 : 1,
                      }
                }
              >
                <div className="flex items-center min-w-0 gap-3">
                  {picture ? <img src={picture} alt="visuel" className={`w-10 h-10 rounded-md flex-shrink-0 ${useIconPicture ? "object-contain bg-white border border-gray-100 p-1" : "object-cover"}`} /> : <div className="w-10 h-10 rounded-md bg-gray-100 flex items-center justify-center text-gray-400 text-xs flex-shrink-0">N/A</div>}
                  <div className="min-w-0">
                    <div className="font-medium text-gray-900 whitespace-normal break-words">{title}</div>
                    {subtitle && <div className="text-sm text-gray-500 whitespace-normal break-words">{subtitle}</div>}
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <button onClick={() => onEdit?.(it)} className="px-2 py-1 text-sm rounded border border-gray-300 text-gray-700 hover:bg-gray-50">
                    Modifier
                  </button>
                  <button onClick={() => onDelete(it)} className="px-2 py-1 text-sm rounded border border-red-300 text-red-700 hover:bg-red-50">
                    Supprimer
                  </button>
                  <div className="flex flex-col space-y-1">
                    <button type="button" onClick={() => onMove?.(it, "up")} disabled={index === 0 || isMoving} className="w-6 h-6 bg-gray-200 hover:bg-gray-300 disabled:bg-gray-100 disabled:cursor-not-allowed rounded flex items-center justify-center transition-colors" title="Monter">
                      <svg className="w-3 h-3 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                      </svg>
                    </button>
                    <button type="button" onClick={() => onMove?.(it, "down")} disabled={index === items.length - 1 || isMoving} className="w-6 h-6 bg-gray-200 hover:bg-gray-300 disabled:bg-gray-100 disabled:cursor-not-allowed rounded flex items-center justify-center transition-colors" title="Descendre">
                      <svg className="w-3 h-3 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SimpleItemsPanel;
